var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marker",class:_vm.classes,style:(_vm.size === 'mini' ? 'min-height: 25px; min-width: 25px;' : 'min-height: 30px; min-width: 30px;')},[_c('div',[_vm._v(_vm._s(_vm.observation.index + 1))])])
}
var staticRenderFns = []

export { render, staticRenderFns }